<template>
  <div class="loader">
    <div class="loader__innerBox loader__innerBoxLeft">
      <img src="/icons/loader/after.svg">
    </div>

    <div class="loader__innerBox">
      <img src="/icons/loader/before.svg">
    </div>
  </div>
</template>

<style lang="scss" scoped>
@keyframes spin {
    100% {
      transform: rotate(360deg);
    }
}

@keyframes antispin {
    100% {
      transform: rotate(-360deg);
    }
}

.loader {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 15.9rem;
  height: 13.9rem;
  animation: spin 6s linear infinite;

    img {
      position: absolute;
      top: 1rem;
      right: 2rem;
      left: unset;
      width: 11.9rem;
      height: 11.9rem;
      animation: antispin 6s linear infinite;
      max-inline-size: 20rem;
    }

    &__innerBox {
      position: relative;
      width: 7.9rem;
      height: 13.9rem;
      overflow: hidden;
    }

    &__innerBoxLeft {

      img {
        right: unset;
        left: 2rem;
      }
    }
}

@include atM {
  .loader {
    width: 23.4rem;
    height: 23.3rem;

    img {
      top: 2rem;
      right: 2rem;
      width: 19.3rem;
      height: 19.3rem;
    }

    &__innerBox {
      width: 11.8rem;
      height: 23.3rem;

      img {
        right: 2rem;
      }
    }
  }
}
</style>
